import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import ArticlePopular from "./ArticlePopular";
import ListBlog from "./ListBlog";

import { ReactComponent as FacebookIcon } from "../../assets/socialmedia/facebook.svg";
import { ReactComponent as WAIcon } from "../../assets/socialmedia/whatapps.svg";
import { ReactComponent as XIcon } from "../../assets/socialmedia/x.svg";
import { useHandleClickLoading } from "../../components/Common/utils";

function DetailBlogPages() {
    const [trendBlogData, setTrendBlog] = useState([]);
    const [detailBlog, setJenisDetailBlog] = useState([]);
    const [jenisArtikeldata, setJenisArtikelData] = useState([]);

    const [trendBlogLoading, settrendBlogLoading] = useState(true);
    const [DetailBlogLoading, setDetailBlogLoading] = useState(true);

    const [limit, setLimit] = useState(3);
    const location = useLocation();
    const handleClickLoading = useHandleClickLoading();
    const dispatch = useDispatch();

    useEffect(() => {
        fetchDataArticle();
        fetchDetailBlog(location.pathname.replace('/news/', ''))
        fetchJenisArticle()
    }, [location]);



    const fetchDataArticle = async () => {
        settrendBlogLoading(true);
        try {
            const response = await ApiService({
                baseurl: "user/jenisBlog?trending",
                method: "GET",
                XGORDON: "JENISBLOG"
            });
            settrendBlogLoading(false);
            if (response?.statusCode === 200) {
                setTrendBlog(response.result.data);
            } else {
                setTrendBlog([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchJenisArticle = async () => {
        try {
            const response = await ApiService({
                baseurl: "user/jenisArtikel",
                method: "GET",
                XGORDON: "JENISARTIKEL"
            });
            if (response?.statusCode === 200) {
                setJenisArtikelData(response.result.data);
            } else {
                setJenisArtikelData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchDetailBlog = async (slug) => {
        setDetailBlogLoading(true);
        const params = new URLSearchParams();
        params.append("slug", slug);

        try {
            const response = await ApiService({
                baseurl: "user/bacaArtikel",
                method: "POST",
                XGORDON: "READARTIKEL",
                body: params,
            });
            setDetailBlogLoading(false);
            if (response?.statusCode === 200) {
                setJenisDetailBlog(response.result);
                // Mengisi data judul
                const judulMeta = document.querySelector('meta[name="title"]');
                judulMeta.setAttribute("content", response.result?.judul);
                document.title = response.result?.judul;
                // Mengisi data deskripsi_meta
                const description = document.querySelector(
                    'meta[name="description"]'
                );
                description.setAttribute("content", response.result?.deskripsi_seo);
                // Mengisi data keywords
                const keywords = document.querySelector('meta[name="keywords"]');
                keywords.setAttribute("content", response.result?.keywords_seo);
                // Mengisi data image
                const images = document.querySelector('meta[name="image"]');
                images.setAttribute("content", response.result?.gambar);
            } else {
                setJenisDetailBlog([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const shareTo = (platform) => {
        const currentURL = window.location.href;
        let shareLink = "";
        switch (platform) {
            case "Facebook":
                // Tautan berbagi ke Facebook
                shareLink = `https://www.facebook.com/share.php?u=${encodeURIComponent(
                    currentURL
                )}`;
                break;
            case "Twitter":
                // Tautan berbagi ke Twitter
                shareLink = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                    currentURL
                )}&text=Your%20tweet%20text%20here`;
                break;
            case "Whatsapp":
                // Tautan berbagi ke Whatsapp
                shareLink = `Whatsapp://send?text=Your%20Whatsapp%20share%20message%20here%20${encodeURIComponent(
                    currentURL
                )}`;
                break;
            default:
                alert("Platform tidak didukung");
                return;
        }
        window.open(shareLink);
    };

    const shareButtons = [
        {
            name: "Facebook",
            bgColor:
                "bg-[#1A6DD4] rounded-sm flex flex-row gap-2 justify-center items-center p-1 p-2",
            textColor: "text-[#ffffff] text-xs sm:flex hidden",
            icon: <FacebookIcon fill="#ffffff" className="w-5 h-5" />,
        },
        {
            name: "Twitter",
            bgColor:
                "bg-[#55ACEF]  rounded-sm flex flex-row gap-2 justify-center items-center p-1 p-2",
            textColor: "text-[#ffffff] text-xs sm:flex hidden",
            icon: <XIcon fill="#ffffff" className="w-5 h-5" />,
        },
        {
            name: "Whatsapp",
            bgColor:
                "bg-[#40E85F]  rounded-sm flex flex-row gap-2 justify-center items-center p-1 p-2",
            textColor: "text-[#ffffff] text-xs sm:flex hidden",
            icon: <WAIcon fill="#ffffff" className="w-5 h-5" />,
        },
    ];

    return (
        <div className="flex flex-col gap-3 flex-1">
            <ListBlog data={jenisArtikeldata} />
            <div className="flex sm:flex-row flex-col gap-3 px-2 ">
                <div className="flex flex-col gap-3 flex-1 ">
                    <div className="flex flex-row gap-2">
                        <span onClick={() => handleClickLoading('/blog')} className="text-base font-semibold cursor-pointer">Home</span>
                        <span className="text-base ">{"  >  "}</span>
                        <span className="text-base font-semibold">{detailBlog?.judul}</span>
                    </div>
                    <div className="flex flex-row w-full">
                        <div className="bg-[#22BDE2] p-1 rounded-tr-lg rounded-bl-lg px-3">
                            <span className="text-[#ffffff] text-left text-sm font-light line-clamp-1">
                                {detailBlog?.jenis}
                            </span>
                        </div>
                    </div>
                    <span className="text-2xl font-semibold">{detailBlog?.judul}</span>
                    <span className="text-xs text-left"><b className="text-[#22BDE2]">Writer</b> - {detailBlog?.tanggal}</span>
                    <div className="flex gap-1 ">
                        {shareButtons.map((button, index) => (
                            <button
                                key={index}
                                className={button.bgColor}
                                onClick={() => {
                                    shareTo(button.name);
                                }}
                            >
                                {button.icon}
                                <span className={button.textColor}>{button.name}</span>
                            </button>
                        ))}
                    </div>
                    <img
                        src={detailBlog?.gambar}
                        alt={detailBlog?.judul}
                        className="w-full object-cover rounded-md aspect-[2/1] pointer-events-none"
                    />
                    <div
                        dangerouslySetInnerHTML={{ __html: detailBlog?.konten }}
                        className={`text-base `}
                    />
                </div>
                <div className=" w-[1px]  border-l border-[#2121211a] dark:border-[#f3f3f31a]" />
                <ArticlePopular data={trendBlogData} loading={trendBlogLoading} />
            </div>
        </div>
    );
}

export default DetailBlogPages;
